//设置专家服务弹框
export const SETTING_EXPERTS_SERVICE = "device/SETTING_EXPERTS_SERVICE";
//设置调试信息弹框
export const SETTING_DEBUGING_INFORMATIONN = "device/SETTING_DEBUGING_INFORMATIONN";

//提醒用户调试信息改变配置
export const SETTING_DEBUGING_INFORMATIONN_REMIND = "device/SETTING_DEBUGING_INFORMATIONN_REMIND";
